import {randomFromArray} from '../../../helpers/random-from-array.js'
import {getCombatantsWithStatus} from '../../analysis/team-analysis-utilities.js'

export function getCursingPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //See if we have valid cursing moves
  const validMoves = getValidCursingMoves(casterActions);
  if (!validMoves.length) {
    return null
  }

  //See if we have any valid enemies to curse
  const validEnemyTargets = getCombatantsWithStatus(enemyCombatants, ["normal"]);
  if (!validEnemyTargets.length) {
    return null
  }

  //Return a random one of our valid moves
  const action = randomFromArray(validMoves);
  const target = randomFromArray(validEnemyTargets);
  return {
    actionModel: action,
    casterModel: casterModel,
    targetModels: [ target ]
  }
}

/** Search array of actions for moves that cause negative statuses */
function getValidCursingMoves(casterActions) {

  return casterActions.filter(action => {

    if (!action.affectTargetStatus) {
      return false
    }
    const resultingStatus = action.affectTargetStatus[1];

    //Add these as needed
    return [
      "memory-leak",
      "lag",
      "fire"
    ].indexOf(resultingStatus) > -1;
  });
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-cursing-path.js